// Duplicate-name display helper (Feb 2026).
//
// Rule: if two or more users share the EXACT same `name` (case-insensitive,
// whitespace-trimmed), append " (1)", " (2)", … to each — sorted by
// `created_at` ascending, tie-broken on `_id`. Single occurrences get no
// suffix.
//
// So "Bram" + "Bram" → "Bram (1)" and "Bram (2)".
// "Bram Blij" + "Bram Scheel" → different names, no suffix on either.
// "Bram Blij" + "Sem Blij" → different names, no suffix.
// "Bram Blij" + "Bram Blij" → "Bram Blij (1)" and "Bram Blij (2)".
export function computeDisplayNames(users = []) {
  const groups = new Map();
  for (const u of users) {
    const key = (u.name || "").trim().toLowerCase();
    if (!key || !u._id) continue;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(u);
  }
  const out = new Map();
  for (const list of groups.values()) {
    if (list.length === 1) {
      out.set(list[0]._id, list[0].name);
      continue;
    }
    // Deterministic ordering: created_at asc, then _id asc.
    list.sort((a, b) => {
      const ac = a.created_at || "";
      const bc = b.created_at || "";
      if (ac !== bc) return ac < bc ? -1 : 1;
      return String(a._id).localeCompare(String(b._id));
    });
    list.forEach((u, i) => out.set(u._id, `${u.name} (${i + 1})`));
  }
  return out;
}
